import React from "react";
import { Card, Typography } from "antd";
import dayjs from "dayjs";
import genderIcon from "../../../assets/patientDetails/gender.svg";
import ageIcon from "../../../assets/patientDetails/age.svg";
import emailIcon from "../../../assets/patientDetails/email.svg";
import phoneIcon from "../../../assets/patientDetails/phone.svg";
import startDateIcon from "../../../assets/patientDetails/startDate.svg";
import facilityIcon from "../../../assets/patientDetails/facility.svg";
import govtIdIcon from "../../../assets/patientDetails/govtId.svg";
import styles from "./PackagesOp.module.css";

const OpBasicDetails = ({ basicDetails }) => {
  const patient = basicDetails?.patient || {};

  const renderRow = (icon, label, value) => (
    <div
      key={label}
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        height: 32,
        gap: 12,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
        <img
          src={icon}
          alt=""
          style={{ width: 32, height: 32, flexShrink: 0 }}
        />
        <span
          style={{
            color: "#4A5565",
            fontSize: 14,
            fontWeight: 400,
            lineHeight: "20px",
            letterSpacing: "-0.15px",
          }}
        >
          {label}
        </span>
      </div>
      <span
        style={{
          color: "#111827",
          fontSize: 14,
          fontWeight: 600,
          lineHeight: "20px",
          letterSpacing: "-0.15px",
          textAlign: "right",
          wordBreak: "break-word",
        }}
      >
        {value ?? (
          <span style={{ color: "#9CA3AF", letterSpacing: 1 }}>----------</span>
        )}
      </span>
    </div>
  );

  const basicRows = [
    {
      icon: facilityIcon,
      label: "Facility",
      value: basicDetails?.facility_name || basicDetails?.facility,
    },
    {
      icon: startDateIcon,
      label: "Start Date",
      value: basicDetails?.admission_date
        ? dayjs(basicDetails.admission_date).format("DD MMM YYYY")
        : patient?.admission_date
        ? dayjs(patient.admission_date).format("DD MMM YYYY")
        : null,
    },
    {
      icon: genderIcon,
      label: "Gender",
      value: patient?.gender ?? null,
    },
    {
      icon: ageIcon,
      label: "Age",
      value: patient?.age ? `${patient.age} years` : null,
    },
    { icon: emailIcon, label: "Email", value: patient?.email },
    { icon: phoneIcon, label: "Phone number", value: patient?.mobile },
    {
      icon: govtIdIcon,
      label: "OP ID",
      value: basicDetails?.op_id,
    },
  ];

  return (
    <Card
      title={
        <Typography.Text strong style={{ fontSize: 14, color: "#111827" }}>
          Basic Information
        </Typography.Text>
      }
      className={`details-card ${styles.basicInfoCard}`}
      bodyStyle={{ padding: "24px" }}
      headStyle={{ background: "#fff", borderBottom: "1px solid #F3F4F6" }}
      style={{ borderRadius: 12, border: "1px solid #E5E7EB" }}
    >
      <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {basicRows.map((row) => renderRow(row.icon, row.label, row.value))}
      </div>
    </Card>
  );
};

export default OpBasicDetails;
